import { useSelector } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'

/**
 * @deprecated useBackgroundJobTracking should be used instead as it provides more features and more stable checking.
 * Finds if there is recent background job with same name and if provided with data matching additional.
 * @param jobType - Name of the job type.
 * @param additional - Additional conditions on background job data.
 * @returns {boolean} - True if there is matching recent background job.
 */
export function useBackgroundJobRunning (jobType, additional = null) {
  const backgroundJobs = useSelector(state => state.backgroundJobs.jobs)

  const timeLimit = moment().subtract(3, 'minutes')
  return backgroundJobs.some(job =>
    job.status === 0 &&
    timeLimit.isBefore(job.creationTime) &&
    job.jobType === jobType &&
    (additional === null || job.data === null || _.isMatch(job.data, additional))
  )
}

/**
 *
 * Prepares function returning Promise for background job tracking. When the job is running the status can be monitored
 * and at the end of the job optional finishCallback will be called.
 * @param startCallback
 * @param finishCallback
 * @return {{running: (boolean|boolean), start: (function(): Promise<unknown>), job: (object|null)}}
 */
export function useBackgroundJobTracking (startCallback, finishCallback = null) {
  const [reference, setReference] = useState(null)
  const [running, setRunning] = useState(false)
  const backgroundJobs = useSelector(state => state.backgroundJobs.jobs)

  const start = useCallback(() => new Promise((resolve, reject) => {
    startCallback()
      .then(x => {
        setReference(x)
        setRunning(true)
        resolve(x)
      })
      .catch(x => reject(x))
  }), [startCallback])

  const job = backgroundJobs.find(job => job.reference === reference)

  if (job && job.status >= 1 && running) {
    setRunning(false)
    if (typeof finishCallback === 'function') finishCallback()
  }

  return { start, running, job: job || null }
}

useBackgroundJobTracking.propTypes = {
  startCallback: PropTypes.func.isRequired,
  finishCallback: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/hooks/useBackgroundJobRunning.js